export const MAIN_TABS = {
  AI_REMOVAL_SUITE: 'ai-removal-suite',
  ID_PHOTO: 'id-photo',
  RESTORATION: 'restoration',
  BACKGROUND_REMOVAL: 'background-removal',
  AI_IMAGE_EXPAND: 'ai-image-expand',
};

export const SUB_TABS = {
  ALL_TYPES: 'all-types',
  WATERMARK_REMOVAL: 'watermark-removal',
  TEXT_REMOVAL: 'text-removal',
  LOGO_REMOVAL: 'logo-removal',
  SIGNATURE_REMOVAL: 'signature-removal',
  STAMP_REMOVAL: 'stamp-removal',
  STICKER_REMOVAL: 'sticker-removal',
};

export type MainTabType = (typeof MAIN_TABS)[keyof typeof MAIN_TABS];
export type SubTabType = (typeof SUB_TABS)[keyof typeof SUB_TABS];

export const TAB_LABELS: Record<MainTabType, string> = {
  [MAIN_TABS.AI_REMOVAL_SUITE]: 'AI Removal Suite',
  [MAIN_TABS.ID_PHOTO]: 'AI Headshot',
  [MAIN_TABS.RESTORATION]: 'Image Restoration',
  [MAIN_TABS.BACKGROUND_REMOVAL]: 'Background Removal',
  [MAIN_TABS.AI_IMAGE_EXPAND]: 'Image Expand',
};
